import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useCallback } from "react";
import { NotificationsSection } from "@/features/admin/home/components/NotificationsSection";
import { useAuth } from "@/context/AuthContext";
import { useNotificationContext } from "@/context/NotificationContext";
import { useAlert } from "@/hooks/useAlert";
import { notificationsService } from "@/api/services/notifications.service";
import { getUserDisplayName } from "@/utils/formatDisplayName";
import styles from "./SurveyorNotificationsPage.module.css";
export const SurveyorNotificationsPage = () => {
    const { user } = useAuth();
    const { confirm } = useAlert();
    const { latestNotification, clearLatestNotification } = useNotificationContext();
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchNotifications = useCallback(async () => {
        try {
            const res = await notificationsService.getMyNotifications({
                unreadOnly: true,
                limit: 50,
            });
            setNotifications(res.data.data);
            setError(null);
        }
        catch {
            setNotifications([]);
            setError("Failed to load notifications.");
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        fetchNotifications();
    }, [fetchNotifications]);
    useEffect(() => {
        if (!latestNotification)
            return;
        setNotifications((prev) => [latestNotification, ...prev]);
        clearLatestNotification();
    }, [latestNotification, clearLatestNotification]);
    const handleNotificationClick = useCallback(async (notification) => {
        const confirmedAction = await confirm("Are you sure you want to close this notification as it will disappear?", "Confirm");
        if (!confirmedAction)
            return;
        const id = notification.id;
        setNotifications((prev) => prev.filter((n) => n.id !== id));
        try {
            await notificationsService.markAsRead(id, {
                actionedByName: getUserDisplayName(user, "Surveyor"),
            });
        }
        catch {
            fetchNotifications();
        }
    }, [confirm, fetchNotifications, user]);
    if (loading) {
        return (_jsx("div", { className: styles.pageContent, children: _jsx("div", { className: styles.loadingState, children: _jsx("p", { children: "Loading notifications..." }) }) }));
    }
    if (error) {
        return (_jsx("div", { className: styles.pageContent, children: _jsxs("div", { className: styles.errorState, children: [_jsx("p", { children: error }), _jsx("button", { onClick: fetchNotifications, children: "Try Again" })] }) }));
    }
    return (_jsx("div", { className: styles.pageContent, children: _jsx("div", { className: styles.notificationsWrapper, children: _jsx(NotificationsSection, { notifications: notifications, onNotificationClick: handleNotificationClick }) }) }));
};
